import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  NgSelectComponent,
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
} from '@ng-select/ng-select';
@Component({
  selector: 'app-text-field',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, NgSelectComponent,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective],
  templateUrl: './text-field.component.html',
  styleUrl: './text-field.component.css'
})
export class TextFieldComponent {
  @ViewChild('inputElement') inputElementRef!: ElementRef;
  @Input() label!: string;
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() control!: any;
  @Input() currencyControl: any;
  @Input() validationMessages: { [key: string]: string } = {};
  @Input() otherInfo: string = ''
  @Input() maxlength: number | null = null;
  @Input() minlength: number | null = null;
  @Output() blur = new EventEmitter<FocusEvent>();
  @Input() disabled: boolean = false;
  @Input() currencyList: any = []
  @Input() rows: any = 3;


  loading: boolean = false;

  get isRequired(): boolean {
    const hasRequired = this.control?.hasValidator?.(Validators.required);
    const hasRequiredTrue = this.control?.hasValidator?.(Validators.requiredTrue);
    return Boolean(hasRequired || hasRequiredTrue);
  }
  // This method is used to error keys
  get errorKeys(): string[] {
    return this.control?.errors ? Object.keys(this.control.errors) : [];
  }

  get currentLength(): number {
    const value = this.control?.value ?? '';
    return typeof value === 'string' ? value.length : value?.toString?.().length ?? 0;
  }
  // This method is used to input classes
  get inputClasses(): string {
    // base
    let cls = 'form-input w-full px-3 py-2 text-dc-navy font-light transition ' +
      'border focus:outline-none disabled:cursor-not-allowed disabled:bg-[#eeeeee]';
    // disabled
    if (this.disabled) {
      return cls + ' bg-gray-200 text-gray-500 cursor-not-allowed';
    }
    // normal
    if (this.control.touched && this.control.invalid) {
      return cls + ' border-red-600';
    }
    if (this.control.touched && this.control.valid) {
      return cls + ' border-green-600';
    }
    return cls + ' border-dc-navy';
  }

  // This method is used to focus
  focus(): void {
    const el = this.inputElementRef?.nativeElement;
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.focus();
    }
  }

  // This method is used to format with thousands separators while typing 
  onAmountInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value || '';

    const hadTrailingDecimal = currentValue.endsWith('.');
    // Remove everything except digits and decimal
    let value: any = currentValue.replace(/[^0-9.]/g, '');

    // Remove commas
    value = value.replace(/,/g, '');

    // Keep only the first decimal point
    const dotIndex = value.indexOf('.');
    if (dotIndex !== -1) {
      const beforeDot = value.slice(0, dotIndex);
      const afterDot = value.slice(dotIndex + 1).replace(/\./g, ''); // remove extra dots
      value = `${beforeDot}.${afterDot}`;
    }

    const hasDecimalPoint = value.includes('.');
    const endsWithDotAfterClean = value.endsWith('.') || hadTrailingDecimal;

    // Split into integer & decimal — NO LIMIT on integer length
    const [rawInteger = '', rawDecimal = ''] = value.split('.');

    const integerPart = rawInteger;
    const decimalPart = rawDecimal.slice(0, 2); //max 2 decimals

    // Format integer with commas
    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    let formattedValue = formattedInt;
    let controlValue = integerPart;

    if (hasDecimalPoint) {
      if (decimalPart) {
        formattedValue = `${formattedInt}.${decimalPart}`;
        controlValue = `${integerPart}.${decimalPart}`;
      } else if (endsWithDotAfterClean) {
        formattedValue = `${formattedInt}.`;
        controlValue = integerPart;
      }
    }
    this.control.setValue(controlValue, { emitEvent: false });
    if (input.value !== formattedValue) {
      input.value = formattedValue;
    }
  }


  // This method is used to handle input change event using event
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (this.maxlength && input.value.length > this.maxlength) {
      input.value = input.value.slice(0, this.maxlength);
      this.control.setValue(input.value); // Update the form control
    }
  }
  // This method is used to handle blur event using event
  onBlur(event: FocusEvent) {
    this.blur.emit(event);
  }

  // This method is used to selection change using e and list
  selectionChange(e: any, list: any = "") {   
     this.blur.emit(e);
  }
}




